module.exports = __webpack_public_path__ + "static/werebear-3c6cf937c0cfcff3c81839b133f0331f.jpg";